/**
 * @fileoverview
 * Tab system to handle display of content based on the selected tab.
 *
 * This file provides a function to initialize the tab system, activate tabs
 * on clicks, and adjust the visible content based on the hash in the URL.
 *
 */




/**
 * Initializes the tab system.
 *
 * Set up click events on tab buttons, handle menu expansion on mobile devices,
 * and triggers the corresponding tab based on the URL hash on page load.
 *
 * @param {string} tabButtonClass - The class for the tab buttons (e.g. '.tab-button').
 * @param {string} tabContentClass - The class of the tab contents (e.g. '.new-tab-content').
 * @param {string} tabContainerClass - The class of the tab container (e.g. '.new-tabs').
 * @param {boolean} activeDefaultInit - Enable the default loading of the tab system
 *
 *
 * @example
 * // Initializes the tab system with the specified classes.
 * initTabs('.tab-button', '.new-tab-content', '.new-tabs');
 */
function initTabs(tabButtonClass, tabContentClass, tabContainerClass, activeDefaultInit) {
  const tabs = document.querySelectorAll(tabButtonClass);
  const contents = document.querySelectorAll(tabContentClass);
  const tabsContainer = document.querySelector(tabContainerClass);

  /**
  * Activates a tab and displays its corresponding content.
  *
  * Deactivates all tabs and content, then activates the tab and content
  * corresponding to the given id.
  *
  * @param {string} target - The id of the tab to activate (e.g. 'plan-free').
  * @returns {void}
  */
  const activateTab = (target) => {
    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => {
      if (content.id === 'tab-content-' + target) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });

    const activeTab = [...tabs].find(tab => tab.getAttribute('data-tab') === target);
    if (activeTab) {
      activeTab.classList.add('active');
    }
  };

  const expandMobileMenu = (tab) => {
    // If it is mobile, change the type of menu
    // opening so that it is displayed downwards and not laterally.
    if (window.innerWidth <= 600) {
      if (tab.classList.contains('active')) {
        tabsContainer.classList.toggle('expanded');
      } else {
        tabsContainer.classList.remove('expanded');
      }
    }
  }

  if (tabs.length > 0) {
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-tab');


        expandMobileMenu(tab);
        activateTab(target);
        history.pushState(null, null, `#${target}`);
      });
    });


    if (activeDefaultInit) {
      //Substring1 remove # from url id
      const hash = window.location.hash.substring(1);
      if (hash) {
        activateTab(hash);
      } else {
        tabs[0].click();
      }
    }
  }
};


/**
 *
 * Initializes the tab system with the specified classes.
 */
document.addEventListener('DOMContentLoaded', () => {
  const isPagePrincingMain = document.getElementById('pagePricingMain');
  if (isPagePrincingMain) {
    initTabs('.tab-button', '.new-tab-content', '.new-tabs', true);
  }else{
    initTabs('.tab-button', '.new-tab-content', '.new-tabs', false);
  }
});
